<template>
  <nav
    class="pager text-center my-3"
    aria-label="Seitennummerierung"
    v-if="Object.keys(dataStore.data).length"
  >
    <div class="pager-info mb-2" :role="withStatusMessage ? 'status' : ''">
      <span class="sr-only">{{ statusHeader }}. Sie befinden sich auf </span>Seite {{ pageUp }} von
      {{ finalPage }} <span class="sr-only">Seiten der Resultaten</span>
    </div>
    <ul class="d-inline-flex nolist">
      <li>
        <button
          :class="{
            pager_num: true,
            disabled: pageUp == 1,
            ophover: pageUp != 1,
            nobutton: true,
          }"
          @click="updatePage(1)"
        >
          &nbsp;<i class="fas fa-angle-double-left"></i>&nbsp;
          <span class="sr-only">zur vorherigen Seite</span>
        </button>
      </li>
      <li v-for="page in pages" class="mx-1">
        <button
          v-if="page == pageUp"
          :class="{
            pager_num: true,
            act: page == pageUp,
            ophover: page != pageUp,
            nobutton: true,
          }"
          aria-current="page"
          @click="updatePage(page)"
        >
          <span class="sr-only">zur Seite:</span> &nbsp;{{ page }}&nbsp;
        </button>
        <button
          v-else
          :class="{
            pager_num: true,
            act: page == pageUp,
            ophover: page != pageUp,
            nobutton: true,
          }"
          @click="updatePage(page)"
        >
          <span class="sr-only">zur Seite:</span> &nbsp;{{ page }}&nbsp;
        </button>
      </li>
      <li>
        <button
          :class="{
            pager_num: true,
            disabled: isFinalPage,
            ophover: !isFinalPage,
            nobutton: true,
          }"
          @click="updatePage(pageUp + 1)"
        >
          &nbsp;<i class="fas fa-angle-double-right"></i>&nbsp;
          <span class="sr-only">zur nächsten Seite</span>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script setup>
import { watch, ref } from "vue";
import { useDataStore } from "@/store/";
import { storeToRefs } from "pinia";

const props = defineProps({
  resultsPerPage: Number,
  withStatusMessage: Boolean
});

const dataStore = useDataStore();
const { data, params } = storeToRefs(dataStore);
const hasPager = ref(dataStore.data?.num_total > dataStore.data?.num_items);
const pages = ref([]);
const pageUp = ref(1);
const finalPage = ref(1);
const isFinalPage = ref(false);
const statusHeader = dataStore.pluginType == "Veranstaltungen" ? "Neue Veranstaltungsergebnisse" : "Neue Apothekenergebnisse"


const updatePage = (page) => {
  const updatePage = Math.max(1, Math.min(page, finalPage.value));
  dataStore.setParams({ ...dataStore.params, page: updatePage });
  dataStore.setPage(updatePage);
  setTimeout(() => {
    dataStore.setFormLoad(false);
    if (!dataStore.formLoad && !dataStore.firstLoad) {
      document.querySelector(".pager_num.act")?.focus();
    }
  }, 1300);
};

const resultsPerPage = props.resultsPerPage ?? 25;

watch(
  data,
  (newVal, oldVal) => {
    hasPager.value = dataStore.data?.num_total > dataStore.data?.num_items;
    pageUp.value = dataStore?.params?.page ?? 1;
    //dataStore.setPage(1);

    if (hasPager) {
      let count = 0;  
      let pagesIn = [];
      let calcedSkip = 0;

      for (let i = 0; i < dataStore.data?.num_total; i += resultsPerPage) {
        count++;
        pagesIn.push(count);
      }

      if (dataStore.data?.merged) {
        if (dataStore.data.mergedGroups.numInside % resultsPerPage !== 0) {
          pagesIn.pop();
        }
      }

      const slicedPagesIn = pagesIn.slice(
        Math.max(0, pageUp.value - 4),
        Math.min(pagesIn.length + 1, pageUp.value + 4)
      );
      pages.value = slicedPagesIn;
      pageUp.value = dataStore?.params?.page ? dataStore?.params?.page : 1;
      finalPage.value = typeof pagesIn[pagesIn.length - 1] !== "undefined" ? pagesIn[pagesIn.length - 1] : 1;
      isFinalPage.value = pageUp.value == finalPage.value;
    }
  },
  { deep: true }
);
</script>
